Librarian.Modules.Announcements = new Class({
    Extends: Librarian.Modules.Module,

    options: {
        classPrefix: "modules-announcements-",
        fileName: null
    },

    initialize: function(options, wrapperEl) {
        this.setOptions(options);
        this.parent(this.options, wrapperEl);
    },

    load: function() {
        if (!this.wrapperEl || !this.options.fileName)
            return;

        this.parent();

        // Generate the URL
        var url = Librarian.path.getMethodUrl("getslidetext") + "&out=ujson&snum=1&fname=" + this.options.fileName;

        this.request = new Librarian.Request.JSON({
            url: url,
            onSuccess: function(json) {
                if (!json)
                    return;

                var lines = json.Text.split('\n');

                // Add each line from the source file as a new item in the announcements list
                lines.forEach(function(line) {
                    new Element("div", {
                        "text": line,
                        "class": (this.options.classPrefix || '') + "announcement"
                    }).injectInside(this.containerEl);
                }.bind(this));
            }.bind(this),
            onFailure: Librarian.Utils.onFailure
        });
        this.request.send();
    }
});